import { createSelector } from 'reselect';

import {
  selectMaxPointsGRSpecificRule,
  selectMaxStakeMultiplicatorGRSpecificRule,
  selectMinStakeMultiplicatorGRSpecificRule,
} from '../../selectors/round.selector';

const selectGRRoundRulesProps = createSelector(
  [selectMaxPointsGRSpecificRule, selectMinStakeMultiplicatorGRSpecificRule, selectMaxStakeMultiplicatorGRSpecificRule],
  (maxPoints, minStakeMultiplicator, maxStakeMultiplicator) => ({
    maxPoints,
    minStakeMultiplicator,
    maxStakeMultiplicator,
  }),
);

export default selectGRRoundRulesProps;
